import { createFileRoute, Outlet } from "@tanstack/react-router";

import { getSettingsSidebarConfig } from "src/staticData";

export const Route = createFileRoute("/_auth/settings")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getLayoutSettings(ctx) {
      return {
        authNavigationTitle: ctx.i18n.t("settings"),
        sidebar: getSettingsSidebarConfig(ctx),
      };
    },
    getBreadcrumb(ctx) {
      return {
        href: "/settings",
        label: ctx.i18n.t("settings"),
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
